import { render, staticRenderFns } from "./CommonLabels.vue?vue&type=template&id=580c744c&scoped=true&"
import script from "./CommonLabels.vue?vue&type=script&lang=js&"
export * from "./CommonLabels.vue?vue&type=script&lang=js&"
import style0 from "./CommonLabels.vue?vue&type=style&index=0&id=580c744c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580c744c",
  null
  
)

export default component.exports